const state = {
    can_close_modal : true,
    imc_core_const : {
        "portal_token" : ""
    },
}

// actions
const actions = {
    LOAD_MAIN_CONST ({commit}) {
        axios.post('/index.php?option=com_imc_docs&task=get_const_data').then(({data}) => {
            if(data.status === 'operation_success') {
                commit('imc_core_const', data.message);
            }
        }).catch(err => {
            console.log(err);
            commit('imc_core_const', {
                "portal_token" : ""
            });
        });
    },
}

// mutations
const mutations = {
    imc_core_const (state, data) {
        state.imc_core_const = {...state.imc_core_const, ...data}
        try {
            i_api.defaults.headers.common['X-PORTAL-TOKEN'] = data.sess;
        }
        catch (e) {
            console.error("Cant Set CORE AXIOS");
        }
    },
}

export default {
    state,
    actions,
    mutations,
}
